/**
 * @file OverviewNotesSection.tsx
 * @description «Заметки о клиенте» на «Обзоре» (phase19.31, SC68):
 * предпочтения и договорённости — текст заметки, автор и дата; «+ Заметка».
 *
 * Заметки не зачёркиваются и не выполняются (SC61). Все заметки — во вкладке
 * «Лента»; здесь последние, что отдал сервер.
 */

import { Plus } from "lucide-react";

import { Button } from "../../ui/button";
import { SectionCard } from "../../ui/SectionCard";
import type { CustomerOverviewNoteDto } from "../../../lib/api-customers-overview";
import { formatShopDate } from "../../../lib/shop-time";

interface Props {
  notes: CustomerOverviewNoteDto[];
  total: number;
  /** Нет — кнопки «+ Заметка» нет (нет права работать с CRM). */
  onAdd?: () => void;
}

export function OverviewNotesSection({ notes, total, onAdd }: Props) {
  return (
    <SectionCard title="Заметки о клиенте" link={total > notes.length ? { label: "Все в ленте", to: "?tab=feed" } : undefined}>
      {notes.length === 0 ? (
        <p className="type-body text-on-surface-variant">Заметок пока нет</p>
      ) : (
        <ul aria-label="Заметки о клиенте" className="flex flex-col divide-y divide-[var(--border)]">
          {notes.map((n) => (
            <li key={n.id} className="flex flex-col gap-0.5 py-2">
              <p className="type-body break-words text-on-surface">{n.title}</p>
              {n.content ? <p className="type-body whitespace-pre-wrap break-words text-on-surface-variant">{n.content}</p> : null}
              <p className="type-caption text-on-surface-variant">
                {[n.authorName, formatShopDate(n.createdAt)].filter(Boolean).join(" · ")}
              </p>
            </li>
          ))}
        </ul>
      )}
      {onAdd ? (
        <Button variant="outline" className="self-start" onClick={onAdd}>
          <Plus className="size-4" aria-hidden />
          Заметка
        </Button>
      ) : null}
    </SectionCard>
  );
}
